module.exports = __webpack_public_path__ + "img/Wp_2021.ec04e4c4.png";